<template>
    <b-card>
        <b-card-header>
            <h1>Personregister</h1>
        </b-card-header>
        <b-card-body>
            <!-- <b-row>
                <b-col cols="4">
                    <b-form-select class="form-control" v-model="newEvent.EventTypeId" :options="GetEventTypes()">
                    </b-form-select>
                </b-col>
            </b-row> -->
            <b-row>
                <b-col>
                    <tableedit v-if="editMode" v-bind:recs="recs" v-bind:cols="fields" v-bind:readonly="!editMode"
                        savebuttontext="Posta in" cancelHidden="true" @save="onSave" @cancel="onCancel">
                    </tableedit>
                </b-col>
            </b-row>

            <!-- <table>
                <thead>
                    <tr>
                        <th v-for="f in fields" :key="f.id">{{ f.caption }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(rec, index) in recs" :key="index">
                        <td v-for="f in fields" :key="f.id">{{ rec[f.field] }}</td>
                    </tr>
                </tbody>
            </table> -->
        </b-card-body>
    </b-card>
</template>
<script>
import tableedit from "../logic/tableedit";
import { Api } from "../../lib/api";
const api = new Api();

//Kortnamn	Märkning	Förnamn	Efternamn	Kundnr	Personnr	Känslighet	Portionsstorlek	Kommentar	Portkod	Adress	Postnr	Postadress	Övriga uppgifter1	Övriga uppgifter2

export default {
    name: 'registeraddresses',
    components: { tableedit },
    data() {
        return {
            recs: [],
            editMode: true,
            fields: [
                //Uppg.lämnare Kortnamn	Märkning	Förnamn	Efternamn	Kundnr	Personnr	Känslighet	Portionsstorlek	Kommentar	Portkod	Adress	Postnr	Postadress	Övriga uppgifter1	Övriga uppgifter2
                { id: 0, caption: "OK", field: "success", type: "boolean", items: null },
                { id: 1, caption: "RESULTAT", field: "errMsg", type: "text", items: null },
                { id: 2, caption: "Uppg.lämnare", field: "regby", type: "text", items: null },
                { id: 3, caption: "Kortnamn", field: "shortname", type: "text", items: null },
                { id: 4, caption: "Märkning", field: "comment", type: "text", items: null },
                { id: 5, caption: "Förnamn", field: "firstname", type: "text", items: null },
                { id: 6, caption: "Efternamn", field: "lastname", type: "string", items: null },
                { id: 7, caption: "Kundnr", field: "customerno", type: "string", items: null },
                { id: 8, caption: "Personnr", field: "persno", type: "string", items: null },
                { id: 9, caption: "Känslighet", field: "sensitivity", type: "string", items: null },
                { id: 10, caption: "Portionsstorlek", field: "portionsize", type: "string", items: null },
                { id: 11, caption: "Kommentar", field: "comment2", type: "string", items: null },
                { id: 12, caption: "Portkod", field: "doorcode", type: "string", items: null },
                { id: 13, caption: "Adress", field: "address", type: "string", items: null },
                { id: 14, caption: "Postnr", field: "postcode", type: "string", items: null },
                { id: 15, caption: "Postadress", field: "postaddress", type: "string", items: null },
                { id: 16, caption: "Övriga uppgifter1", field: "other1", type: "string", items: null },
                { id: 17, caption: "Övriga uppgifter2", field: "other2", type: "string", items: null },
                { id: 18, caption: "Övriga uppgifter3", field: "other3", type: "string", items: null },
                { id: 19, caption: "Övriga uppgifter4", field: "other4", type: "string", items: null },
                { id: 20, caption: "Övriga uppgifter5", field: "other5", type: "string", items: null },
                { id: 21, caption: "Övriga uppgifter6", field: "other6", type: "string", items: null },
                { id: 22, caption: "Övriga uppgifter7", field: "other7", type: "string", items: null },
                { id: 23, caption: "Övriga uppgifter8", field: "other8", type: "string", items: null },
                { id: 24, caption: "Övriga uppgifter9", field: "other9", type: "string", items: null },
                { id: 25, caption: "Övriga uppgifter10", field: "other10", type: "string", items: null },
            ]
        }
    },
    methods: {
        onSave(r) {
            if (confirm("Vill du posta in nytt personregister?")) {
                var dt = [];
                // r.forEach(x => {
                //     if (x && x.revisedCost) {
                //         dt.push({
                //             tspDocNo: x.tspDocNo, comment: x.comment, productKey: x.productKey, revisedCost: Number(String(x.revisedCost)
                //                 .replace(' ', '')
                //                 .replace(',', '.'))
                //         });
                //     }
                // });
                dt = JSON.parse(JSON.stringify(r));
                if (dt.length == 0) {
                    alert('Finns inga poster att lägga in.');
                    return;
                }
                //var dt = r.map(x => { return {tspDocNo: x.tspDocNo, comment: x.comment, productKey: x.productKey, revisedCost: Number(x.revisedCost.replace(',','.'))}});
                api.post('/api/sodexo/registeraddresses', dt).then(res => {
                    this.recs = res.data;
                    // for(var i = 0; i < r.length; i++) {
                    //     var rec = this.recs[i];
                    //     res.result = r[i].errMsg;
                    //     res.success = r[i].success;
                    // }
                    alert('Poster behandlade. Se resultat i resultatkolumnen.')
                });
            }

        },
        onCancel(r) {
            if (confirm("Vill du avbryta?")) {
                this.recs = [];
            }
        }
    }
}
</script>